/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { P } from "@cd2/text"
import { HoverResourceLoader } from "./HoverResourceLoader"
import { IRecord } from "../types/schema"
import { defaultSettings, IBranchSettings } from "../utils/useSettings"

type IBranch = IRecord<"branches", "name"> & { settings: IBranchSettings }

interface IProps {
  id: string
  initialData?: IBranch
  nameOverride?: string
  inline?: boolean
}

export function HoverBranchLoader({ id, initialData, nameOverride, inline }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const branch = await skeem.fetchOne<IBranch>({
      branches: {
        attributes: ["name", "settings"],
        filter: { matches: { id } },
      },
    })
    return {
      ...branch,
      settings: {
        ...defaultSettings,
        ...branch.settings,
        useExplicitAllocations: !!branch.settings?.useExplicitAllocations,
      },
    }
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      resourceName="Branch"
      renderHoverContent={record => (
        <P css={css("white-space: pre")}>{record.settings.pdfAddress}</P>
      )}
      renderTarget={record => nameOverride ?? record.name}
      inline={inline}
    />
  )
}
